<form [formGroup]="templateForm"  (ngSubmit)="saveCurrentTemplate()" class="{{editorClass}}">
<ion-grid>
    <ion-row class="editor-header-row">
        <ion-col size="4" class="editor-field-col">
            <ion-item lines='none' class="form-inputs ion-no-padding">
                <div class="info-block">
                    <ion-label position="stacked"> {{ 'Name' | translate}} *
                    </ion-label>
                    <ion-icon *ngIf="showInfoIcon" src="../../../assets/icon/Info_Icon.svg" class="info-icon" tooltip="{{ 'template_info' | translate}}"
                        placement="bottom"></ion-icon>
                </div>
                <ion-input type='text' placeholder="{{ 'Enter_Name' | translate}}" formControlName="name"
                    [(ngModel)]="templateName" (ionInput)="onChangeName()" required>
                </ion-input>
            </ion-item>
        </ion-col>
        <ion-col size="4" class="editor-field-col">
            <div class="each_div">
                <ion-label position="stacked"> {{ 'Language' | translate}} *</ion-label>
                <ng-select #languageSelect [(ngModel)]="selectedLangauge" placeholder="{{ 'Select_Language' | translate}}"
                    formControlName="langauge" class="placeholder-color" (change)="onChangeLanguage($event)"
                    (clear)="onLanguageCleared()" (keydown)="onLanguageClearKeydown($event)"
                    [virtualScroll]='true'>
                    <ng-option *ngFor="let language of languages"
                        [value]="language?.value">{{language?.label}}</ng-option>
                </ng-select>
            </div>
        </ion-col>
        <ion-col size="4" class="right-btn editor-actions-col">
            <div class="editor-utility-actions margin-top-24">
                <!-- <div class="a4-zoom-control" role="group" aria-label="A4 document zoom">
                    <button type="button" class="a4-zoom-btn" [disabled]="a4Scale <= minA4Scale"
                        (click)="zoomOutA4()" tooltip="Zoom Out" placement="bottom" aria-label="Zoom Out">
                            <img src="/assets/icon/zoom_out.png" alt="" class="a4-zoom-icon" />
                    </button>
                    <button type="button" class="a4-zoom-btn" [disabled]="a4Scale >= maxA4Scale"
                        (click)="zoomInA4()" tooltip="Zoom In" placement="bottom" aria-label="Zoom In">
                            <img src="/assets/icon/zoom_in.png" alt="" class="a4-zoom-icon" />
                    </button>
                </div> -->
                <ion-button class="ruler-toggle-btn" shape="round" fill="outline" color="primary" type="button"
                    (click)="toggleRuler()" tooltip="{{ (showRuler ? 'hide_ruler' : 'show_ruler') | translate }}" placement="bottom">
                    <ion-icon name="resize-outline"></ion-icon>
                </ion-button>
            </div>
            <div class="editor-form-actions margin-top-24">
                <ion-button class="ruler-toggle-btn" shape="round" fill="outline" color="primary"
                    [disabled]="!allowTyping || !isCurrentPageDirty() || isSaveInProgress()" (click)="saveCurrentPage()">
                    {{'Save'|translate}}
                </ion-button>
                <ion-button class="ruler-toggle-btn btn-margin-30" shape="round" fill="outline" color="primary"
                    (click)="exit()">
                    {{'Exit'|translate}}
                </ion-button>
            </div>
        </ion-col>
    </ion-row>
</ion-grid>
</form>
<div class="auto-save-text">
    <span *ngIf="a4StatusMessage" [ngClass]="{'disable-typing': a4StatusMessageType === 'warning', 'a4-info-status': a4StatusMessageType === 'info'}">{{ a4StatusMessage | translate }}</span>
    <span *ngIf="!a4StatusMessage && !allowTyping" class="disable-typing">{{'Content exceeds A4 page limit...please remove some content'| translate}}.</span>
    <span *ngIf="!a4StatusMessage && allowTyping && isCurrentPageDirty()" class="unsaved-status">{{'Unsaved_Changes_Title'| translate }}</span>
    <span *ngIf="!a4StatusMessage && allowTyping && !isCurrentPageDirty()">{{'Content saved'| translate }}.</span>
</div>
<div class="editor-container">
    <div class="sidebar">
        <div class="page-list-card-header">
            {{ 'Page_List' | translate }}
            <img tabindex="0" type="button" class="add-icon" tooltip="{{ 'Add_New_Page' | translate }}" placement="bottom"
                src="/assets/images/add-circle-outline.svg" (keydown.enter)="addNewPage()" (click)="addNewPage()" alt="" />
        </div>
        <div cdkDropList (cdkDropListDropped)="drop($event)" class="page-list">
            <div *ngFor="let page of pages" tabindex="0" type="card" class="page-item draggable-item" [class.active]="activePage === page.id" cdkDrag
                role="button" (click)="changePage(activePage, page.id)" (keydown.enter)="changePage(activePage, page.id)">
                <input type="text" readonly tabindex="-1" placeholder="'Page ' + (pages.indexOf(page) + 1)" [value]="page.title"
                    (input)="updatePageTitle(page.id, $any($event.target).value)"
                    class="page-title-input">
                    <img tabindex="0" type="button"  class="remove-icon" tooltip="{{ 'Remove_Page' | translate }}" placement="bottom"
                    [ngClass]="{'active-icon': activePage === page.id}" src="/assets/images/remove-circle-outline.svg"
                    (keydown.enter)="$event.stopPropagation(); deleteConfirmation(page.id)"
                    (click)="$event.stopPropagation(); deleteConfirmation(page.id)" alt="" />
            </div>
        </div>
    </div>

        <!-- Editor area -->
        <div class="editor-area right a4-page">
            <!-- Page-scale view: canvas keeps its fixed A4 width; zoom changes visual scale only. -->
            <div class="a4-scale-viewport" #a4ScaleViewport [attr.id]="froalaPopupViewportId">
                <div class="a4-zoom-stage" #a4ZoomStage>
                    <div class="a4-scale-canvas" #a4ScaleCanvas>
        <!-- Ruler -->
        <div class="ruler-container" *ngIf="showRuler">
            <div class="ruler" #rulerElement
                 (mousemove)="onRulerMouseMove($event)"
                 (mouseleave)="onRulerMouseLeave()"
                 (click)="onRulerClick($event)">
                <div class="ruler-inner">
                    <div class="ruler-mark" *ngFor="let mark of rulerMarks" 
                         [style.left.px]="mark.position"
                         [class.major]="mark.type === 'major'"
                         [class.medium]="mark.type === 'medium'"
                         [class.minor]="mark.type === 'minor'">
                        <span class="ruler-label" *ngIf="mark.label">{{mark.label}}</span>
                    </div>
                    <!-- Hover guide indicator on ruler -->
                    <div class="ruler-hover-indicator" 
                         *ngIf="hoverGuidePosition !== null && isHoveringRuler"
                         [style.left.px]="hoverGuidePosition">
                    </div>
                    <!-- Persistent guide indicators on ruler -->
                    <div class="ruler-persistent-indicator" 
                         *ngFor="let guide of persistentGuides"
                         [style.left.px]="guide"
                         (click)="removeGuide(guide); $event.stopPropagation()">
                    </div>
                </div>
            </div>
            <!-- Clear guides button -->
            <button class="clear-guides-btn" 
                    *ngIf="persistentGuides.length > 0"
                    (click)="clearAllGuides()"
                    tooltip="{{ 'Clear All Guides' | translate }}" 
                    title="{{ 'Clear All Guides' | translate }}"
                    placement="bottom">
                <ion-icon name="close-circle-outline"></ion-icon>
            </button>
        </div>
        
        <!-- Guide lines overlay for editor -->
        <div class="guide-lines-overlay" *ngIf="showRuler">
            <!-- Hover guide line -->
            <div class="guide-line hover-guide" 
                 *ngIf="hoverGuidePosition !== null && isHoveringRuler"
                 [style.left.px]="hoverGuidePosition">
            </div>
            <!-- Persistent guide lines -->
            <div class="guide-line persistent-guide" 
                 *ngFor="let guide of persistentGuides"
                 [style.left.px]="guide">
            </div>
        </div>
        
        <textarea [froalaEditor]="options" placeholder="{{ 'write_something_placeholder' | translate }}"
         [(ngModel)]="currentPageContent"
         id="editor_froala"
            (ngModelChange)="onContentChange($event)">
        </textarea>
                    </div>
                </div>
      </div>
    </div>
</div>
<!--  -->